
export * from '../../../frontend-js-node-shims/__liferay__/exports/path.js';
